import React from "react";
import dragAvatar from "images/dragAvatar.png";

const HlpDragAvatar = () => {
  return (
    <>
      <h1>Click & Drag Your Avatar to Hear and See Others</h1>
      Only the people who are in range can see or hear you.
      <img
        style={{ marginBottom: 0 }}
        src={dragAvatar}
        alt="dragging avatar around"
      />
    </>
  );
};

export default HlpDragAvatar;
